import { Fragment, type FunctionComponent } from "react";
import { useDispatch, useSelector } from "react-redux";
import { actionCreators, State } from "@App/state";
import { Generation } from "@App/types";
import { useTranslation } from "react-i18next";
import { GenerationList } from "@App/Components/Vehicletree/GenerationList/GenerationList";
import { bindActionCreators } from "@reduxjs/toolkit";
import { FunnelHeader } from "@App/Components/Funnel/FunnelHeader";
import { Loader } from "@App/Components/Loader";

export type GenerationsProps = {
  headline: string;
  step: number;
  maxSteps: number;
  onKeyNumberLinkClick: () => void;
  onSubmit?: (generation: Generation) => void;
};

export const Generations: FunctionComponent<GenerationsProps> = ({
  headline,
  step,
  maxSteps,
  onKeyNumberLinkClick,
  onSubmit,
}: GenerationsProps) => {
  const { t } = useTranslation();
  const brand = useSelector((state: State) => state.orders.brand);

  const dispatch = useDispatch();
  const { chooseGeneration } = bindActionCreators(actionCreators, dispatch);

  const setGeneration = (generation: Generation): void => {
    chooseGeneration(generation);
    onSubmit && onSubmit(generation);
  };

  if (!brand) {
    return (
      <div className="h-screen w-screen grid place-items-center">
        <Loader />
      </div>
    );
  }

  return (
    <Fragment>
      <div
        className="
                    container bg-white
                    pt-10 pb-12
                "
      >
        <FunnelHeader
          heading={headline}
          step={step}
          maxSteps={maxSteps}
          subheading={t("generation.choose-model", { brand: brand.name })}
        />
        <div className="text-sm text-neutral-700 mb-8">
          <i>
            {t("generation.skip-steps")}{" "}
            <span
              className={"font-bold cursor-pointer underline text-primary"}
              onClick={onKeyNumberLinkClick}
            >
              {t("generation.vehicle-registration")}
            </span>
            .
          </i>
        </div>
        <GenerationList onClick={setGeneration} />
      </div>
    </Fragment>
  );
};
